<template>
    <div class="system-code">
        <TableSearch :searchConfig="searchConfig" :searchParams="searchParams" @search="searchData"></TableSearch>
        <Table :tableLoading="tableLoading"
               :templateData="tableData"
               :tableConfig="tableConfig"
               :pagination="pagination">
            <el-button type="primary" @click="addCode('添加字典类型')">添加字典类型</el-button>
        </Table>
        <el-dialog
                :close-on-click-modal="false" :close-on-press-escape="false"
                :title="dialogTitle"
                :visible.sync="dialogVisible"
                width="500px"
                :before-close="handleForm">
            <div class="">
                <el-form :model="codeForm" :rules="formRules" ref="codeForm" label-width="150px" class="demo-ruleForm">
                    <el-form-item label="字典类型名称" prop="codeName">
                        <el-input maxLength='50' v-model="codeForm.codeName" placeholder="请输入字典类型名称"></el-input>
                    </el-form-item>
                    <el-form-item   label="字典类型" prop="codeValue">
                        <el-input maxLength='50' v-model="codeForm.codeValue" :disabled="(dialogTitle==='字典类型修改'||dialogTitle==='字典修改')" placeholder="请输入字典类型"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                  <el-button @click="handleForm()">取 消</el-button>
                  <el-button type="primary" @click="submitForm('codeForm')">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
                :close-on-click-modal="false" :close-on-press-escape="false"
                :title="dialogTitleTwo"
                :visible.sync="dialogVisibleTwo"
                width="500px"
                :before-close="handleFormTwo">
            <div class="">
                <el-form :model="codeFormTwo" :rules="formRulesTwo" ref="codeFormTwo" label-width="150px" class="demo-ruleForm">
                    <el-form-item  label="字典名称" prop="itemName">
                        <el-input maxLength='50' v-model="codeFormTwo.itemName" placeholder="请输入字典名称"></el-input>
                    </el-form-item>
                    <el-form-item   label="字典值" prop="itemValue">
                        <el-input maxLength='50' v-model="codeFormTwo.itemValue" :disabled="(dialogTitle==='字典类型修改'||dialogTitle==='字典修改')" placeholder="请输入字典类型"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                            <el-button @click="handleFormTwo()">取 消</el-button>
                             <el-button type="primary" @click="submitFormTwo('codeFormTwo')">确 定</el-button>
                          </span>
        </el-dialog>

        <el-dialog
                :close-on-click-modal="false" :close-on-press-escape="false"
                :title="iteemCodeTitle"
                :visible.sync="dialogVisible2"
                width="700px"
                :before-close="handleForm2">
            <div class="" >
                <Table :tableLoading="tableLoading2"
                       :templateData="tableData2"
                       :tableConfig="tableConfig2"
                       :pagination="pagination2">
                    <el-button type="primary" @click="addCode('添加字典')">添加字典</el-button>
                </Table>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {setSystemApi} from '../../../../api-path/district-api'
    import Table from '../../../../components/table/table'
    import TableSearch from '../../../../components/tabel-search/tabel-search'

    export default {
        components: {  Table,  TableSearch},
        name: "system-code",
        data() {
            return {
                iteemCodeTitle:'',
                dialogTitle: '',
                dialogVisible: false,
                dialogVisible2:false,
                tableLoading2: false,
                tableLoading: false,
                dialogTitleTwo:'',
                dialogVisibleTwo:false,
                codeFormTwo:{
                    id: '',//字典ID --修改用
                    codeValue:'',
                    itemName:'',
                    itemValue:'',
                },
                codeForm: {
                    id: '',//字典类型ID --修改用
                    codeName: '', //字典类型名称
                    codeValue: '',//值
                },
                formRulesTwo:{
                    itemName:[{ required: true, message: '请输入字典名称', trigger: 'blur' }  ],
                    itemValue:[{ required: true, message: '请输入字典值', trigger: 'blur' }],
                },
                formRules: {
                    codeName: [{ required: true, message: '请输入字典类型名称', trigger: 'blur' }],
                    codeValue: [{ required: true, message: '请输入字典类型名称', trigger: 'blur' }],
                },
                /*--------search-------*/
                searchConfig: {
                    dataName: 'searchParams',
                    items: [
                        {
                            key: 'code',
                            placeholder: '请输入字典名称'
                        }
                    ]
                },
                searchParams: {
                    code: '', //字典类型
                    page: 1,
                    size: 10,
                },

                /*------tabel--------*/
                tableConfig: {
                    checkbox: false,
                    index: false,
                    rows: [
                        {
                            label: '字典类型名称',
                            prop: 'codeName',
                            fn: (data) => {
                                this.searchParams2.codeValue=data.codeValue;
                                this.dialogVisible2=true;
                                this.searchData2();
                            }
                        }, {
                            label: '值',
                            prop: 'codeValue',
                        },

                    ],
                    //表格操作
                    rowButtons: {
                        items: [
                            {
                                label: '修改',
                                fn: this.editCode
                            },{
                                label: '删除',
                                type:'danger',
                                fn: this.delCode
                            }
                        ]
                    }
                },
                pagination: {
                    show: true,
                    total: 0,
                    page: 1,
                    size: 10,
                    sizeChange: this.sizeChange,
                    pageChange: this.pageChange,
                },
                tableData: [], //数据字典数据
               //------------item table-------------
                tableConfig2: {
                    checkbox: false, index: true,
                    rows: [
                        {
                            label: '字典名称',
                            prop: 'itemName',
                        },{
                            label: '值',
                            prop: 'itemValue',
                        },
                    ],
                    //表格操作
                    rowButtons: {
                        items: [
                            {
                                label: '修改',
                                fn: this.editCode
                            },
                            {
                                label: '删除',
                                type:'danger',
                                fn: this.delCode
                            }
                        ]
                    }
                },
                pagination2: {
                    show: true,
                    total: 0,
                    page: 1,
                    size: 10,
                    sizeChange: this.sizeChange2,
                    pageChange: this.pageChange2,
                },
                tableData2: [], //数据字典数据
                searchParams2: {
                    codeValue: '', //字典类型
                    page: 1,
                    size: 10,
                },
            }
        },
        created() {
            this.searchData()
        },
        methods: {
            //表格数据
            searchData(data) {
                if(data){ this.searchParams.page = this.pagination.page= 1;}

                let params = {};
                this.tableLoading = true;
                Object.keys(this.searchParams).forEach(key => {
                    if (this.searchParams[key] !== '' && this.searchParams[key] != null) params[key] = this.searchParams[key]
                });
                this.$http.get(setSystemApi.queryListByPage, {params}).then((res) => {
                    this.tableLoading = false;
                    if (res.status === 200) {
                        this.pagination.total = res.result.total;
                        this.tableData = res.result.pageList;
                    }
                })
            },
            searchData2(){
                this.$http.get(setSystemApi.itemQueryListByPage, {params:this.searchParams2}).then((res) => {
                    this.tableLoading = false;
                    if (res.status === 200) {
                        this.pagination2.total = res.result.total;
                        this.tableData2 = res.result.pageList;
                    }
                })
            },
            sizeChange(size) {
                this.pagination.size = size;
                this.searchParams.size = size;
                this.searchData()
            },
            pageChange(page) {
                this.pagination.page = page;
                this.searchParams.page = page;
                this.searchData();
            },
            sizeChange2(size) {
                this.pagination2.size = size;
                this.searchParams2.size = size;
                this.searchData2()
            },
            pageChange2(page) {
                this.pagination2.page = page;
                this.searchParams2.page = page;
                this.searchData2();
            },
            addCode(item) {

                if(item=='添加字典'){
                    this.dialogTitleTwo = item ;
                    this.dialogVisibleTwo = true;
                }else {
                    this.dialogTitle = item ;
                    this.dialogVisible = true;
                }
            },
            editCode(data) {
                if(!data.itemValue){
                    this.dialogTitle = '字典类型修改';
                    this.dialogVisible = true;
                    this.codeForm = {...data}
                }else {
                    this.dialogTitle = '字典修改';
                    this.dialogVisibleTwo = true;
                    this.codeFormTwo = {...data}
                }


            },
            delCode(data){
                let url='';
                this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                        if(!data.itemValue){
                            url=`${setSystemApi.delSysCode}`
                        }else { //
                            url=`${setSystemApi.itemDelSysCode }`
                        }
                    this.$http.post(url, {ids:[data.id]}).then(res => {
                        if(res.status === 200) {
                            this.$message.success('删除成功');
                            if(!data.itemValue){
                                this.searchData();
                            }else { //
                                this.searchData2();
                            }

                        }
                    })

                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });


            },
            handleForm() {
                this.codeForm = {...this.$options.data().codeForm}
                this.dialogVisible = false;
            },
            handleFormTwo(){
                this.codeFormTwo = {...this.$options.data().codeFormTwo}
                this.dialogVisibleTwo = false;
            },
            handleForm2() {
                this.dialogVisible2 = false;
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.$http.post(setSystemApi.saveSysCode, this.codeForm).then(res => {
                            if(res.status === 200) {
                                this.$message.success('保存成功');
                                this.handleForm();
                                this.searchData();
                            }
                        })
                    } else {
                        return false;
                    }
                });
            },
            submitFormTwo(formName){
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.codeFormTwo.codeValue=this.searchParams2.codeValue;
                        this.$http.post(setSystemApi.itemSaveSysCode, this.codeFormTwo).then(res => {
                            if(res.status === 200) {
                                this.$message.success('保存成功');
                                this.handleFormTwo();
                                this.searchData2();
                            }
                        })

                    } else {
                        return false;
                    }
                });
            }
        }
    }
</script>

<style lang="less" scoped>
	.system-code{
		margin-left: 10px;
		height: 100%;
		background: #fff;
		border-radius:10px ;
		padding: 10px;
		box-sizing: border-box;
	}
</style>
